import {
  isBannerOnlyEditStatus,
  isFullyReadOnlyStatus,
} from "./campaignEditLocks";
import type { DynamicBonusCampaignStatus } from "./types";

/**
 * Accepts undefined so callers can invoke this above a loading early-return.
 * Drafts are fully editable. Active/paused/expired stay banner-only.
 * Archived is fully read-only.
 */
export const useCampaignEditLocks = (
  status: DynamicBonusCampaignStatus | undefined,
): { isFullyReadOnly: boolean; isBannerOnlyEdit: boolean } => {
  if (!status) {
    return { isFullyReadOnly: false, isBannerOnlyEdit: false };
  }

  return {
    isFullyReadOnly: isFullyReadOnlyStatus(status),
    isBannerOnlyEdit: isBannerOnlyEditStatus(status),
  };
};
